import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

const DeviceImage = props => (
    <StaticQuery
      query={graphql`
        query {
            images: allFile(filter: { sourceInstanceName: { eq: "images" } }) {
                edges {
                    node {
                        relativePath
                        name
                        childImageSharp {
                            fluid(maxWidth : 176) {
                                ...GatsbyImageSharpFluid_noBase64
                                presentationWidth
                            }
                        }
                    }
                }
            }
        }
    `}
      render={data => {
            const image = data.images.edges.find(n => {
            return n.node.relativePath.includes(props.imgSrc);
        });
        if (!image) {
          return null;
        }
  
        return <Img alt={props.alt} fluid={image.node.childImageSharp.fluid} fadeIn={true}
        style={{
          maxWidth: image.node.childImageSharp.fluid.presentationWidth,
          margin: "0 auto",
        }} />;
      }}
    />
  );
  
  export default DeviceImage;